if (!customElements.get('collection-description')) {
  customElements.define(
    'collection-description',
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        // A previously registered element can connect before the parser has added its children.
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized) return;

        const full = this.querySelector('[data-description-full]');
        const preview = this.querySelector('[data-description-preview]');
        const button = this.querySelector('button');
        const wordLimit = Number.parseInt(this.dataset.wordLimit, 10);

        if (!full || !preview || !button || !Number.isInteger(wordLimit) || wordLimit < 1) return;

        full.hidden = false;
        preview.hidden = true;
        button.hidden = true;

        // Read text independently of animation visibility, preserving block and line-break boundaries.
        const readText = (node) => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent;
          if (node.nodeType !== Node.ELEMENT_NODE || node.matches('script, style, template, noscript')) return '';

          const display = getComputedStyle(node).display;
          if (display === 'none') return '';
          if (node.tagName === 'BR') return ' ';

          const content = Array.from(node.childNodes, readText).join('');
          return display === 'inline' || display === 'contents' ? content : ` ${content} `;
        };
        const text = readText(full).trim();
        const words = text ? text.split(/\s+/u) : [];
        if (words.length <= wordLimit) return;

        this.initialized = true;
        preview.textContent = `${words.slice(0, wordLimit).join(' ')}…`;

        const setExpanded = (expanded) => {
          full.hidden = !expanded;
          preview.hidden = expanded;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
        };

        button.addEventListener('click', () => {
          setExpanded(button.getAttribute('aria-expanded') !== 'true');
        });

        setExpanded(false);
        button.hidden = false;
      }
    }
  );
}
